module.exports = "<div #mpgsCheckoutRef></div>\r\n<Netlink-header></Netlink-header> <!--//\"Kowsalya: Text changed for NLT PRP portal development \"-->\r\n<flow-header></flow-header>\r\n<router-outlet></router-outlet>\r\n<pop-up-confirmation></pop-up-confirmation>"


//////////////////
// WEBPACK FOOTER
// /home/maheshreddy/PRP_FE/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main